import React, { useEffect, useState } from 'react'
import useHttp from '../../../../hooks/use-http'
import { DEVICE, FOND_MODES, apiGenerator, convertUTCToLocal } from '../../../../util/functions'
import CONSTANTS from '../../../../util/constant/CONSTANTS'
import Heading from '../../../../component/common/Heading'
import moment from 'moment'

const FeederInfo = ({ feederConnectionId }) => {
    const [device, setDevice] = useState({})
    const api = useHttp()
    console.log(device);
    const commonClass = 'text-base font-medium py-2';
    const commonSpanClass = 'text-[#94A3BAE0]';




    useEffect(() => {
        if (feederConnectionId) {
            const PET_FEEDER_API = apiGenerator(CONSTANTS.API.Feeder_Connection.getOne, { id: feederConnectionId },)
            api.sendRequest(PET_FEEDER_API, (res) => {
                setDevice(res)
            },)
        }
    }, [feederConnectionId])
    return (
        <>
            <div>
                {feederConnectionId ?
                    <>
                        <Heading >Device Details</Heading>
                        <div className='my-2 flex gap-4 '>
                            <div>
                                <p className={`${commonClass}`}><span className={`${commonSpanClass}`}> Feeder ID :</span> {`FEE${device?.data?.feedarId?.toString()?.padStart(5, '0')}`}</p>
                                <p className={`${commonClass}`}><span className={`${commonSpanClass}`}> Version Number :</span> {device?.data?.feedar?.firmwareVersion}</p>
                                <p className={`${commonClass}`}><span className={`${commonSpanClass}`}> Battery Level :</span> {device?.data?.feederData?.length > 0 ? `${device?.data?.feederData[0]?.batteryLevel} %` : '-'}</p>
                                {/* <p className={`${commonClass}`}><span className={`${commonSpanClass}`}> WIFI connectivity status :</span> {device?.active ? 'Yes' : 'No'}</p> */}
                                <p className={`${commonClass}`}><span className={`${commonSpanClass}`}> Average food consumption per day :</span> {device?.data?.averageFoodConsumed ? `${device?.data?.averageFoodConsumed} gm` : '-'} </p>
                                <p className={`${commonClass}`}><span className={`${commonSpanClass}`}> Time Slots :</span> {device?.data?.feederTimings?.map((item) => <><span>{item?.time}</span>&nbsp;</>)}</p>
                                <p className={`${commonClass}`}><span className={`${commonSpanClass}`}>Latest Setup date  :</span> {convertUTCToLocal(device?.firstSetupDate, 'DD MMMM, YYYY')}</p>
                                <p className={`${commonClass}`}><span className={`${commonSpanClass}`}>First Setup date  :</span> {convertUTCToLocal(device?.data?.createdAt, 'DD MMMM, YYYY')}</p>
                            </div>

                        </div>
                    </> :
                    <>
                        <p className='text-base mt-5 text-red-600 font-medium py-2'>Pet is not connected with feeder</p></>}

            </div>
        </>
    )
}

export default FeederInfo